import { render, staticRenderFns } from "./AccountLinkCard.vue?vue&type=template&id=446b5f14&scoped=true&"
import script from "./AccountLinkCard.vue?vue&type=script&lang=js&"
export * from "./AccountLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountLinkCard.vue?vue&type=style&index=0&id=446b5f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b5f14",
  null
  
)

component.options.__file = "AccountLinkCard.vue"
export default component.exports